export default () => {
	let popular = document.querySelector('.popular__card')
	let schedule = document.querySelector('.show--link')
	let objOfTags = {
		общее: 'linear-gradient(to right, #58b59b 0%, #3d93b2 100%)',
		'золотая коллекция мосфильма': 'linear-gradient(to right, #da3cbe 0%, #ac2bec 100%)',
		'мосфильм гранд': 'linear-gradient(to right, #ee565b 0%, #e60ca6 98%, #e60ca6 100%)',
		'золотая коллекция вгтрк': 'linear-gradient(to right, #8e35da 0%, #2a2ded 98%, #2a2ded 100%)',
		'детское кино': 'linear-gradient(to right, #ffc600 0%, #ff6d00 100%)',
		артхаус: 'linear-gradient(to right, #12e26f 0%, #0ca852 100%)',
		'современное кино': 'linear-gradient(to right, #4e73ff 0%, #37b1fe 100%)',
	}

	function gradient() {
		const hexValues = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e']

		function populate(a) {
			for (let i = 0; i < 6; i++) {
				let x = Math.round(Math.random() * 14)
				let y = hexValues[x]
				a += y
			}
			return a
		}

		const newColor1 = populate('#')
		const newColor2 = populate('#')

		const gradient = `linear-gradient(to right, ${newColor1} 0%, ${newColor2} 100%)`

		return gradient
	}

	popular
		? document.querySelectorAll('.popular__card .card__genre').forEach((el) => {
				let tagFromElement = el.innerText.toLowerCase()
				let value = gradient()

				if (tagFromElement === '') {
					el.innerText = 'Общее'
					tagFromElement = el.innerText.toLowerCase()
				}

				for (let tag in objOfTags) {
					tag === tagFromElement ? (value = objOfTags[tag]) : null
				}

				let check = localStorage.getItem(tagFromElement)

				if (check === null && tagFromElement !== '') {
					localStorage.setItem(tagFromElement, value)
				}
		  })
		: schedule
		? document.querySelectorAll('.show--link .show__genre').forEach((el) => {
				let tagFromElement = el.innerText.toLowerCase()
				let value = gradient()

				if (tagFromElement === '') {
					el.innerText = 'Общее'
					tagFromElement = el.innerText.toLowerCase()
				}

				for (let tag in objOfTags) {
					tag === tagFromElement ? (value = objOfTags[tag]) : null
				}

				let check = localStorage.getItem(tagFromElement)

				if (check === null && tagFromElement !== '') {
					localStorage.setItem(tagFromElement, value)
				}
		  })
		: null

	popular
		? document.querySelectorAll('.popular__card .card__right').forEach((el) => {
				let genre = el.querySelector('.card__genre').innerText.toLowerCase()
				el.classList.contains('card_1') ||
				el.classList.contains('card_2') ||
				el.classList.contains('card_3') ||
				el.classList.contains('card_4') ||
				el.classList.contains('card_5') ||
				el.classList.contains('card_6')
					? null
					: (el.style.backgroundImage = gradient)
		  })
		: schedule
		? document.querySelectorAll('.show--link .show__genre').forEach((el) => {
				let genre = el.innerText.toLowerCase()
				let gradient = localStorage.getItem(genre)

				el.style.backgroundImage = gradient
		  })
		: null
}
